
export const styles = (theme: any) => {
    return {
        RowContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        Input: {
            paddingRight: 10
        },
        Divider: {
            width: '100%'
        },
        CalendarButtonsContainer: {
            display: 'flex',
            justifyContent: 'space-evenly',
            padding: 10
        },
        CalendarContainer: {
            minWidth: 350
        }
    }
}